// extracted by mini-css-extract-plugin
export default {"small":"Text_small__UX7rk","medium":"Text_medium__KBUe7","large":"Text_large__iP0cP","huge":"Text_huge__ieVFO","normal":"Text_normal__Xi6i0","bold":"Text_bold__0Dq-s"};